import { QueryClient, useQueryClient } from 'react-query'

/**
 * Alternative to {@link useQueryClient} intended only for use in class components.
 */
interface QueryClientProps {
  children: (queryClient: QueryClient) => any
}
export const ReactQueryClient: React.FC<QueryClientProps> = ({ children }) => {
  const queryClient = useQueryClient()
  return children(queryClient)
}
